// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"52":"6bbf8c2c","5477":"66ac3dd4","7088":"db4376d4"}[chunkId] + ".chunk.css";
};